import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { BasicCustomMailSetting } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchCustomMailSetting = ({ hotelID }: Props) => {
	return useCustomSuspenseQuery(BasicCustomMailSetting, { variables: { hotelID } });
};
